import { NgModule } from '@angular/core';
import {
  RouterModule,
  Routes,
  provideRouter,
  withComponentInputBinding,
} from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { LayoutComponent } from './pages/layout/layout.component';
import { RDataAggregatesPage } from './pages/rdata-aggregates/rdata-aggregates.component';
import { RDataContractDetailsPage } from './pages/rdata-contract-details/rdata-contract-details.component';
import { RDataRecordsPage } from './pages/rdata-records/rdata-records.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { authRedirectGuard } from './guards/auth-redirect.guard';

const routes: Routes = [
  {
    path: '',
    component: SignInComponent,
    canActivate: [authRedirectGuard],
    pathMatch: 'full',
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [MsalGuard],
    canActivateChild: [MsalGuard],
    children: [
      {
        path: 'rdata-aggregates',
        title: 'rData Aggregates',
        component: RDataAggregatesPage,
      },
      {
        path: 'rdata-records',
        title: 'rData Records',
        component: RDataRecordsPage,
      },
      {
        path: 'rdata-records/contract/:id',
        title: 'rData Contract Record',
        component: RDataContractDetailsPage,
      },
    ],
  },
  {
    path: '**',
    title: 'Resolve.com Practice Portal',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      onSameUrlNavigation: 'reload',
      scrollPositionRestoration: 'disabled',
    }),
  ],
  exports: [RouterModule],
  providers: [provideRouter(routes, withComponentInputBinding())],
})
export class AppRoutingModule {}
